import {
  PosterProject,
  StyledPoint,
  MapLabel,
  MapLabelStyle,
} from "PosterEditor/model/poster-project";

export type StyleElement = "pointerAndBorder" | "shadow";

export const applyLabelStyleToAllPointsInProject = (
  newStyle: MapLabelStyle,
  element: StyleElement,
  project: PosterProject
): StyledPoint[] => {
  const points = project.styledPoints.map((point) => {
    const label = point.label;
    if (label) {
      const newLabel: MapLabel = {
        ...label,
        style: {
          ...label.style,
          backgroundColor: newStyle.backgroundColor,
          backgroundOpacity: newStyle.backgroundOpacity,
          padding: newStyle.padding,
          decorationStyle: { ...newStyle.decorationStyle },
          pointerColor: newStyle.pointerColor,
          pointerThickness: newStyle.pointerThickness,
          showPointer: newStyle.showPointer,
          textColor: newStyle.textColor,
          font: newStyle.font,
          fontSize: newStyle.fontSize,
          isUppercase: newStyle.isUppercase,
          borderRadius: newStyle.borderRadius,
          borderWidth: newStyle.borderWidth,
          borderColor: newStyle.borderColor,
          imageSize: newStyle.imageSize,
          shadow: newStyle.shadow ? { ...newStyle.shadow } : undefined,
        },
      };
      const newPoint = { ...point, label: newLabel };
      return newPoint;
    }
    return point;
  });
  return points;
};
